








































import { Component, Vue, Watch } from 'vue-property-decorator'
import EventBus from '@/plugins/EventBus'
import { maskDateTime } from '@/utils/common'

@Component

export default class ComponentRecebimentoItemInfoSituacao extends Vue {
  showDialogInfoSituacao: boolean = false
  infoSituacaoDefault: any = {
    motivosDivergencia: [],
    dataRecebimentoNotaFiscal: '',
    observacaoDivergencia: '',
  }

  infoSituacao: any = { ...this.infoSituacaoDefault }

  maskDateTimeUtil(value) {
    return maskDateTime(value)
  }

  @Watch('showDialogInfoSituacao')
  onChangeshowDialogInfoSituacao(value: boolean) {
    if (!value) {
      this.infoSituacao = { ...this.infoSituacaoDefault }
    }
  }

  mounted() {
    EventBus.$on('infoSituacao', (data: any) => {
      this.showDialogInfoSituacao = data.open
      this.infoSituacao = { ...data.item }
    })
  }
}

